import {Stack, TextField} from '@wellstone-solutions/web';
import {ChecklistSection, useNoteForm} from '../../../NoteForm';
import {SERVICE_ACTIVITIES} from '../../choices';
import type {ContactNoteAction, ContactNoteState} from '../../state';
import {PlaceOfServiceField} from './PlaceOfServiceField';

export const ServiceSection = () => {
  const {state, dispatch} = useNoteForm<ContactNoteState, ContactNoteAction>();

  return (
    <Stack spacing={3}>
      <PlaceOfServiceField />
      <ChecklistSection
        required
        label="Case management service provided"
        otherLabel="Other activity (specify)"
        options={SERVICE_ACTIVITIES}
        value={state.activities}
        onToggle={(key) => dispatch({type: 'toggle', field: 'activities', key})}
        onOtherChange={(value) =>
          dispatch({type: 'setOther', field: 'activities', value})
        }
      />
      <TextField
        required
        label="Specific member need addressed"
        value={state.specificNeed}
        onChange={(event) =>
          dispatch({
            type: 'set',
            field: 'specificNeed',
            value: event.target.value,
          })
        }
      />
      <TextField
        required
        multiline
        minRows={3}
        label="Describe the case-management intervention"
        value={state.serviceDescription}
        onChange={(event) =>
          dispatch({
            type: 'set',
            field: 'serviceDescription',
            value: event.target.value,
          })
        }
      />
    </Stack>
  );
};
